/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable max-classes-per-file */
import { OptionItem } from '@/model/OptionItem';

export const OrderStateModuleNameSpace = 'order/';

export enum OrderStoreEnum {
  SET_SELECTED_BANK = 'SET_SELECTED_BANK_',
  SAVE_ORDER_INPUT = 'SAVE_ORDER_INPUT',
}

export class BankInfo {
  bankCode = '';

  bankName = '';

  cardNo = '';

  cardType = 0;

  extendInfo: any = {};

  id = ''; // !!

  thirdApplyId = ''; // 第三方的绑卡id

  orderNo = 0;

  support = true;

  bankMobile = ''; // 新增回传手机号

  aliPay = ''; // 支付宝id
}

export class LastOrderInput {
  amount = 0;

  periodSelectIndex = 0;

  repaymentModelsSelectIndex = 0;

  bankInfo: BankInfo = new BankInfo();

  selectedUsage: OptionItem = {} as any;

  agreement = false;
}

class OrderState {
  lastInputs: { [key: string]: LastOrderInput } = {};

  lastSelectedBank: any = new BankInfo();
}

export class OrderStore {
  namespaced = true;

  state: OrderState = new OrderState();

  mutations: any = {
    [OrderStoreEnum.SET_SELECTED_BANK]: (
      state: OrderState,
      bankInfo: any,
      ...rest: any
    ) => {
      state.lastSelectedBank = bankInfo;
    },
    [OrderStoreEnum.SAVE_ORDER_INPUT]: (
      state: OrderState,
      payload: any,
      ...rest: any
    ) => {
      const { commodityId, inputs } = payload;
      const lastInput = this.getters.getSavedOrderInputs(state)(commodityId);
      Object.assign(lastInput, inputs);
    },
  };

  actions: any = {};

  getters: any = {
    getSavedOrderInputs: (state: OrderState) => (
      commodityId: string,
    ): LastOrderInput => {
      // tslint:disable-next-line
      if (state.lastInputs[commodityId] === undefined) {
        state.lastInputs[commodityId] = new LastOrderInput();
      }
      return state.lastInputs[commodityId];
    },
  };
}

export const order = new OrderStore();
